import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';


import './index.scss';

import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import NotFoundPage from "./pages/NotFoundPage";
import {LoadFormData} from "./context/FormDataContext";

const root = ReactDOM.createRoot(document.getElementById('root'));

const router = createBrowserRouter([{
    path: "/",
    element:
        <LoadFormData>
            <App />
        </LoadFormData>
}, {
    path: "*",
    element: <NotFoundPage />
}])

root.render(
  // <React.StrictMode>
    <RouterProvider router={router} />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
